import { useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import { assertNever } from './assert-never';
var ScrollPosition = /*#__PURE__*/function (ScrollPosition) {
  ScrollPosition["Top"] = "top";
  ScrollPosition["Bottom"] = "bottom";
  return ScrollPosition;
}(ScrollPosition || {});
export const useAutoScrolling = (selectedItem, parentNodeRef) => {
  const shouldScrollToItemTopRef = useRef(false);
  const selectedItemContentRef = useRef(null);
  const selectedItemHeaderRef = useRef(null);
  useEffect(() => {
    let timeout;
    if (selectedItemContentRef.current && selectedItem) {
      shouldScrollToItemTopRef.current = true;
      timeout = setTimeout(() => {
        scrollToItem(ScrollPosition.Top, {
          itemContentRef: selectedItemContentRef,
          itemHeaderRef: selectedItemHeaderRef,
          parentNodeRef
        });
        shouldScrollToItemTopRef.current = false;
      }, 500);
    }
    return () => {
      clearTimeout(timeout);
      shouldScrollToItemTopRef.current = false;
    };
  }, [parentNodeRef, selectedItem]);
  return {
    selectedItemContentRef,
    selectedItemHeaderRef
  };
};
const ITEM_PADDING_BOTTOM = 42;
const SCROLL_MARGIN = 10;
const ITEM_HEADER_PADDING = 12;
const scrollToItem = (position, _ref) => {
  let {
    parentNodeRef,
    itemContentRef,
    itemHeaderRef
  } = _ref;
  const scrollerNode = ReactDOM.findDOMNode(parentNodeRef == null ? void 0 : parentNodeRef.current);
  const headerNode = itemHeaderRef.current;
  const contentNode = itemContentRef.current;
  if (!scrollerNode || !headerNode || !contentNode) {
    return;
  }
  const nodes = {
    contentNode,
    headerNode,
    scrollerNode
  };
  const {
    isTopVisible,
    isBottomVisible
  } = isVisible(nodes);
  const {
    topY,
    scrollToBottomTopY
  } = getItemBounds(nodes);
  const scrollToItemTop = !isTopVisible || !isBottomVisible ? () => {
    scrollerNode.scrollTo({
      behavior: 'smooth',
      top: topY
    });
  } : null;
  const scrollToItemBottom = !isBottomVisible ? () => scrollerNode.scrollTo({
    behavior: 'smooth',
    top: scrollToBottomTopY
  }) : null;
  position === ScrollPosition.Top ? scrollToItemTop == null ? void 0 : scrollToItemTop() : position === ScrollPosition.Bottom ? scrollToItemBottom == null ? void 0 : scrollToItemBottom() : assertNever(position);
};
const getItemBounds = _ref2 => {
  let {
    scrollerNode,
    headerNode,
    contentNode
  } = _ref2;
  const scrollTop = scrollerNode.scrollTop;
  const {
    top: scrollerTop
  } = scrollerNode.getBoundingClientRect();
  const {
    top: headerTop
  } = headerNode.getBoundingClientRect();
  const {
    bottom: contentBottom
  } = contentNode.getBoundingClientRect();
  const topY = headerTop + scrollTop - scrollerTop - ITEM_HEADER_PADDING - SCROLL_MARGIN;
  const bottomY = contentBottom + scrollTop - scrollerTop + ITEM_PADDING_BOTTOM + SCROLL_MARGIN;
  const scrollToBottomTopY = bottomY - scrollerNode.clientHeight;
  return {
    bottomY,
    scrollToBottomTopY,
    topY
  };
};
const isVisible = ItemsListNodes => {
  const {
    scrollerNode
  } = ItemsListNodes;
  const {
    topY,
    bottomY
  } = getItemBounds(ItemsListNodes);
  let isTopVisible = false;
  let isBottomVisible = false;
  if (scrollerNode) {
    const {
      scrollTop,
      clientHeight
    } = scrollerNode;
    isTopVisible = topY >= scrollTop;
    isBottomVisible = bottomY <= scrollTop + clientHeight;
  }
  return {
    isBottomVisible,
    isTopVisible
  };
};
//# sourceMappingURL=use-auto-scrolling.js.map